import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const allEducationList = createAsyncThunk(
    "allEducationList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/education/fetch-education-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const EducationListSlice = createSlice({
    name: "EducationListSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(allEducationList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(allEducationList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(allEducationList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default EducationListSlice.reducer;
